// import React, { useEffect, useState } from "react";
// import { Table, Button, Tag, message, Space, Card, Layout, Select, Typography } from "antd";
// import axios from "axios";
// import { BASE_URL } from "../../Config";
// import Sidebar from "../../Components/Sidebar";
// import {
//   MenuOutlined,
// } from "@ant-design/icons";
// const { Header } = Layout;
// const { Text } = Typography;

// const UserAsanaApproval = () => {
//   const [asanas, setAsanas] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const admin = JSON.parse(localStorage.getItem("admin"));
//   const role = admin?.role || "admin";

//   useEffect(() => {
//     const checkScreen = () => setIsMobile(window.innerWidth <= 768);
//     checkScreen();
//     window.addEventListener("resize", checkScreen);
//     return () => window.removeEventListener("resize", checkScreen);
//   }, []);

//   const fetchAsanas = async () => {
//     try {
//       setLoading(true);
//       const token = sessionStorage.getItem("token");

//       const res = await axios.get(`${BASE_URL}/userasanas`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setAsanas(res.data.asanas || []);
//     } catch (err) {
//       message.error("Failed to load user asanas");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAsanas();
//   }, []);

//   const approveAsana = async (id) => {
//     try {
//       const token = sessionStorage.getItem("token");

//       await axios.put(
//         `${BASE_URL}/userasanas/approve/${id}`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       message.success("Asana approved successfully!");
//       fetchAsanas();
//     } catch (error) {
//       message.error("Failed to approve");
//     }
//   };

//   const rejectAsana = async (id) => {
//     try {
//       const token = sessionStorage.getItem("token");

//       await axios.put(
//         `${BASE_URL}/userasanas/reject/${id}`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       message.success("Asana rejected");
//       fetchAsanas();
//     } catch (error) {
//       message.error("Failed to reject");
//     }
//   };

//   const columns = [
//     {
//       title: "User",
//       dataIndex: "userId",
//       render: (user) => <span>{user?.name || "Unknown User"}</span>,
//     },
//     {
//       title: "Asana Name",
//       dataIndex: "name",
//       render: (_, row) => <b>{row.name}</b>,
//     },
//     {
//       title: "Level",
//       dataIndex: "level",
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       render: (status) => {
//         const color =
//           status === "pending"
//             ? "orange"
//             : status === "approved"
//               ? "green"
//               : "red";

//         return <Tag color={color}>{status.toUpperCase()}</Tag>;
//       },
//     },
//     {
//       title: "Actions",
//       render: (_, row) => (
//         <Space>
//           {row.status === "pending" && (
//             <>
//               <Button type="primary" onClick={() => approveAsana(row._id)}>
//                 Approve
//               </Button>

//               <Button danger onClick={() => rejectAsana(row._id)}>
//                 Reject
//               </Button>
//             </>
//           )}

//           {row.status !== "pending" && (
//             <Tag color={row.status === "approved" ? "green" : "red"}>
//               {row.status}
//             </Tag>
//           )}
//         </Space>
//       ),
//     },
//   ];

//   const MobileAsanaCard = ({ item }) => {
//     const statusColor =
//       item.status === "pending"
//         ? "orange"
//         : item.status === "approved"
//           ? "green"
//           : "red";

//     return (
//       <Card
//         style={{
//           marginBottom: 16,
//           borderRadius: 16,
//         }}
//         bodyStyle={{ padding: 16 }}
//       >
//         {/* Top Row */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//           }}
//         >
//           <div>
//             <div style={{ fontSize: 12, color: "#888" }}>
//               {item.userId?.name || "Unknown User"}
//             </div>

//             <div
//               style={{
//                 fontSize: 18,
//                 fontWeight: 600,
//               }}
//             >
//               {item.name}
//             </div>
//           </div>

//           <Tag style={{height: "fit-content"}} color={statusColor}>
//             {item.status.toUpperCase()}
//           </Tag>
//         </div>

//         {/* Level */}
//         <div style={{ marginTop: 10 }}>
//           <span style={{ color: "#888" }}>Level: </span>
//           <Tag color="blue">{item.level}</Tag>
//         </div>

//         {/* Actions */}
//         <div
//           style={{
//             marginTop: 16,
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: 8,
//           }}
//         >
//           {item.status === "pending" && (
//             <>
//               <Button
//                 type="primary"
//                 onClick={() => approveAsana(item._id)}
//               >
//                 Approve
//               </Button>

//               <Button
//                 danger
//                 onClick={() => rejectAsana(item._id)}
//               >
//                 Reject
//               </Button>
//             </>
//           )}
//         </div>
//       </Card>
//     );
//   };

//   return (
//     <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen}
//         setMobileOpen={setMobileOpen}
//         isMobile={isMobile}
//         collapsedWidth="0"
//       />

//       <Layout
//         className="main-layout"
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
//           transition: "0.3s",
//           padding: isMobile ? 10 : 20,
//         }}
//       >
//         <Header
//           className="MainHeader"
//         >
//           {isMobile && (
//             <Button
//               type="text"
//               icon={<MenuOutlined />}
//               onClick={() => setMobileOpen(true)}
//               style={{ fontSize: 18, marginRight: 12 }}
//             />
//           )}
//           <div style={{ flex: 1 }}>
//             <Text style={{ fontSize: 20, fontWeight: "bold" }}>All Asanas</Text>
//           </div>
//         </Header>
//         <Card
//           title="User Submitted Asanas"
//           style={{ margin: 20, borderRadius: 12, boxShadow: "0 4px 12px #ddd" }}
//         >
//           {isMobile ? (
//             loading ? (
//               <p>Loading...</p>
//             ) : (
//               asanas.map((item) => (
//                 <MobileAsanaCard
//                   key={item._id}
//                   item={item}
//                 />
//               ))
//             )
//           ) : (
//             <Table
//               columns={columns}
//               dataSource={asanas}
//               rowKey="_id"
//               loading={loading}
//             />
//           )}
//         </Card>
//       </Layout>
//     </Layout>
//   );
// };

// export default UserAsanaApproval;

import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Tag,
  message,
  Space,
  Card,
  Layout,
  Typography,
  Modal,
  Descriptions,
  Image,
  Spin,
  Select,
  Checkbox,
} from "antd";
import { EyeOutlined, MenuOutlined } from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../../Config";
import Sidebar from "../../Components/Sidebar";

const { Header } = Layout;
const { Text } = Typography;
const { Option } = Select;
const UserAsanaApproval = () => {
  const [asanas, setAsanas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [rewardPlan, setRewardPlan] = useState(null);
  const [withLogo, setWithLogo] = useState(false);

  // View modal
  const [viewOpen, setViewOpen] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    fetchAsanas();
  }, []);

  const fetchAsanas = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/userasanas`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAsanas(res.data.asanas || []);
    } catch {
      message.error("Failed to load user asanas");
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (id) => {
    setViewOpen(true);
    setViewData(null);
    setViewLoading(true);
    setRewardPlan(null);
    setWithLogo(false);
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/userasanas/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setViewData(res.data);
    } catch {
      message.error("Failed to load details");
      setViewOpen(false);
    } finally {
      setViewLoading(false);
    }
  };

  const approveAsana = async (id) => {
    try {
      const token = sessionStorage.getItem("token");
      await axios.put(
        `${BASE_URL}/userasanas/approve/${id}`,
        { rewardPlan: rewardPlan || undefined, withLogo },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      message.success(
        rewardPlan
          ? `Asana approved! Reward (${rewardPlan}) granted to user.`
          : "Asana approved successfully!",
      );
      fetchAsanas();
    } catch {
      message.error("Failed to approve");
    }
  };
  const rejectAsana = async (id) => {
    try {
      const token = sessionStorage.getItem("token");
      await axios.put(
        `${BASE_URL}/userasanas/reject/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      message.success("Asana rejected");
      fetchAsanas();
    } catch {
      message.error("Failed to reject");
    }
  };

  const statusColor = (s) =>
    s === "pending" ? "orange" : s === "approved" ? "green" : "red";

  const columns = [
    {
      title: "User",
      dataIndex: "userId",
      render: (user) => <span>{user?.name || "Unknown User"}</span>,
    },
    {
      title: "Asana Name",
      dataIndex: "name",
      render: (_, row) => <b>{row.name}</b>,
    },
    {
      title: "Level",
      dataIndex: "level",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <Tag color={statusColor(status)}>{status.toUpperCase()}</Tag>
      ),
    },
    {
      title: "Actions",
      render: (_, row) => (
        <Button type="link" onClick={() => handleView(row._id)}>
          {row.status === "pending" ? "Review" : "View"}
        </Button>
      ),
    },
  ];

  const MobileAsanaCard = ({ item }) => (
    <Card
      style={{ marginBottom: 16, borderRadius: 16 }}
      bodyStyle={{ padding: 16 }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: 12, color: "#888" }}>
            {item.userId?.name || "Unknown User"}
          </div>
          <div style={{ fontSize: 18, fontWeight: 600 }}>{item.name}</div>
        </div>
        <Tag style={{ height: "fit-content" }} color={statusColor(item.status)}>
          {item.status.toUpperCase()}
        </Tag>
      </div>

      <div style={{ marginTop: 10 }}>
        <span style={{ color: "#888" }}>Level: </span>
        <Tag color="blue">{item.level}</Tag>
      </div>

      <div
        style={{
          marginTop: 16,
          display: "flex",
          justifyContent: "flex-end",
          gap: 8,
        }}
      >
        <Button type="link" onClick={() => handleView(item._id)}>
          {item.status === "pending" ? "Review" : "View"}
        </Button>
      </div>
    </Card>
  );

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
      />

      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >
        <Header className="MainHeader">
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}
          <div style={{ flex: 1 }}>
            <Text style={{ fontSize: 20, fontWeight: "bold" }}>
              User Asana Approvals
            </Text>
          </div>
        </Header>

        <Card
          title="User Submitted Asanas"
          style={{ margin: 20, borderRadius: 12, boxShadow: "0 4px 12px #ddd" }}
        >
          {isMobile ? (
            loading ? (
              <p>Loading...</p>
            ) : (
              asanas.map((item) => (
                <MobileAsanaCard key={item._id} item={item} />
              ))
            )
          ) : (
            <Table
              columns={columns}
              dataSource={asanas}
              rowKey="_id"
              loading={loading}
            />
          )}
        </Card>
      </Layout>

      {/* ── View Details Modal ── */}
      <Modal
        title="Asana Details"
        open={viewOpen}
        onCancel={() => setViewOpen(false)}
        footer={
          viewData?.status === "pending" ? (
            <Space>
              <Button onClick={() => setViewOpen(false)}>Close</Button>
              <Button
                danger
                onClick={() => {
                  rejectAsana(viewData._id);
                  setViewOpen(false);
                }}
              >
                Reject
              </Button>
             <Button
  type="primary"
  style={{ background: "#10b981", borderColor: "#10b981" }}
  onClick={async () => {
    await approveAsana(viewData._id);
    setViewOpen(false);
  }}
>
  Approve
</Button>
            </Space>
          ) : (
            <Button onClick={() => setViewOpen(false)}>Close</Button>
          )
        }
        width={isMobile ? "95vw" : 700}
        centered
      >
        {viewLoading ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            <Spin size="large" />
          </div>
        ) : viewData ? (
          <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label="Name">{viewData.name}</Descriptions.Item>
            <Descriptions.Item label="Sanskrit">
              {viewData.sanskrit || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Tamil">
              {viewData.tamil || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="English">
              {viewData.english || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Level">
              {viewData.level || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Breath">
              {viewData.breath || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Chakra">
              {viewData.chakra || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Pose Type">
              {viewData.poseType?.join(", ") || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="How To Do">
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                {viewData.howToDo?.map((s, i) => (
                  <li key={i}>{s}</li>
                ))}
              </ul>
            </Descriptions.Item>
            <Descriptions.Item label="Benefits">
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                {viewData.benefits?.map((b, i) => (
                  <li key={i}>{b}</li>
                ))}
              </ul>
            </Descriptions.Item>
            <Descriptions.Item label="Precautions">
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                {viewData.precautions?.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ul>
            </Descriptions.Item>
            <Descriptions.Item label="Submitted By">
              {viewData.userId?.name || viewData.userId?.email || "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Status">
              <Tag color={statusColor(viewData.status)}>
                {viewData.status?.toUpperCase()}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Main Image">
              {viewData.mainImage ? (
                <Image
                  width={isMobile ? "100%" : 260}
                  src={viewData.mainImage}
                  style={{ borderRadius: 10 }}
                />
              ) : (
                "—"
              )}
            </Descriptions.Item>
            {viewData.variationPoses?.length > 0 && (
              <Descriptions.Item label="Variation Poses">
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {viewData.variationPoses.map((vp, i) => (
                    <div key={i} style={{ textAlign: "center", fontSize: 12 }}>
                      {vp.image && (
                        <Image
                          width={64}
                          height={64}
                          src={vp.image}
                          style={{ borderRadius: 6, objectFit: "cover" }}
                        />
                      )}
                      <div>{vp.title || vp.sanskrit || `Pose ${i + 1}`}</div>
                    </div>
                  ))}
                </div>
              </Descriptions.Item>
            )}
            {viewData?.status === "pending" && (
              <Descriptions.Item label="Reward (Optional)">
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    Extend all user variation expiry as reward for submitting
                    this asana
                  </Text>
                  <Select
                    placeholder="No reward"
                    allowClear
                    value={rewardPlan}
                    onChange={(val) => {
                      setRewardPlan(val);
                      if (!val) setWithLogo(false);
                    }}
                    style={{ width: "100%" }}
                  >
                    <Option value="basic-1">Basic-1 · least days</Option>
                    <Option value="basic-2">Basic-2 · moderate days</Option>
                    <Option value="standard">Standard · good days</Option>
                    <Option value="premium">Premium · most days</Option>
                  </Select>
                  {rewardPlan && (
                    <Checkbox
                      checked={withLogo}
                      onChange={(e) => setWithLogo(e.target.checked)}
                    >
                      Include logo watermark (fewer bonus days)
                    </Checkbox>
                  )}
                </div>
              </Descriptions.Item>
            )}
          </Descriptions>
        ) : null}
      </Modal>
    </Layout>
  );
};

export default UserAsanaApproval;
